export const LogConstants = {
    LOG_CURRENT_PAGE: "LOG_CURRENT_PAGE",
    LOG_LIMIT_PER_PAGE: "LOG_LIMIT_PER_PAGE",

    GET_LOG_SUCCESS: "GET_LOG_SUCCESS",
    LOG_LIMIT: "LOG_LIMIT",
    GET_LOG_ERROR: "GET_LOG_ERROR",
    LOG_LOADING: "LOG_LOADING",
};
